(function () {
  var quotes = [
    { text: "Flow Tank", attr: "India" },
    { text: "Everyday Joggers", attr: "India" },
    { text: "Edge Tank", attr: "Powai" },
    { text: "Power Crop", attr: "India" },
  ];
  var index = 0;
  var timer = null;

  function overlayOpen() {
    var o = document.getElementById("wearthOverlayDrawer");
    return o && o.getAttribute("data-state") === "open";
  }

  function rotate() {
    if (!overlayOpen()) return;
    var block = document.querySelector("[data-wearth-drawer-quote]");
    if (!block) return;
    var textEl = block.querySelector("[data-quote-text]");
    var attrEl = block.querySelector("[data-quote-attr]");
    if (!textEl || !attrEl) return;
    index = (index + 1) % quotes.length;
    textEl.style.opacity = "0";
    window.setTimeout(function () {
      if (!overlayOpen()) return;
      textEl.textContent = quotes[index].text;
      attrEl.textContent = quotes[index].attr;
      textEl.style.opacity = "1";
    }, 350);
  }

  function startRotation() {
    if (timer) return;
    timer = window.setInterval(rotate, 5200);
  }

  function stopRotation() {
    if (!timer) return;
    window.clearInterval(timer);
    timer = null;
    var textEl = document.querySelector("[data-quote-text]");
    if (textEl) textEl.style.opacity = "1";
  }

  document.addEventListener("wearth:overlay-open", function () {
    window.setTimeout(startRotation, 6000);
  });

  document.addEventListener("wearth:overlay-close", stopRotation);

  if (overlayOpen()) startRotation();
})();
